// extracted by mini-css-extract-plugin
export default {"shareUrlPopup":"shareUrlPopup__shareUrlPopup__WGYyF"};